import { useCallback } from "react"
import { usePipelineStore } from "../stores/PipelineStore"
import { changeValueIfStringIntoNumber, currencyFormatter, roundDecimalToTwo, unformatNumberInput } from "../functions/general"

interface UseHandleChangeResultPriceAndTotalProps {
    discountProduct: string
    discountType: 'NOMINAL' | 'PERCENTAGE'
    priceProduct: string
    qtyProduct: string
    vatProduct: string
    isIncludeVat: boolean
    originalPriceProduct: string | number
    setTotalProduct: (totalProduct: string) => void
    setPriceProduct: (priceProduct: string) => void
    setDiscountProduct: (discountProduct: string) => void
}
const useHandleChangeResultPriceAndTotal = ({ discountProduct, discountType, priceProduct, qtyProduct, vatProduct, isIncludeVat, originalPriceProduct, setTotalProduct, setPriceProduct, setDiscountProduct }: UseHandleChangeResultPriceAndTotalProps) => {
    const { selectMultiPipeline } = usePipelineStore()

    const handleChangeValueResultTotal = useCallback(() => {
        const discountValue = changeValueIfStringIntoNumber(discountProduct)
        const qtyValue = unformatNumberInput(qtyProduct)
        const vatPercentage = Number(vatProduct)
        const newPrice = typeof priceProduct === 'string' ? changeValueIfStringIntoNumber(priceProduct) : priceProduct

        let totalAfterVAT = 0;
        let discountAmount = 0;

        if (isIncludeVat) {
            if (discountType === 'PERCENTAGE') {
                discountAmount = (discountValue / 100) * newPrice;
            } else {
                discountAmount = discountValue;
            }

            const priceAferVat = newPrice + (vatPercentage / 100) * newPrice
            const priceAfterDiscount = priceAferVat - discountAmount;

            const totalAfterDiscount = priceAfterDiscount * qtyValue;
            totalAfterVAT = totalAfterDiscount
        } else {
            const productPrice = originalPriceProduct ?
                (typeof originalPriceProduct === 'string' ? changeValueIfStringIntoNumber(originalPriceProduct) : originalPriceProduct) :
                changeValueIfStringIntoNumber(priceProduct)

            if (discountType === 'PERCENTAGE') {
                discountAmount = (discountValue / 100) * productPrice;
            } else {
                discountAmount = discountValue;
            }

            const total = qtyValue * (productPrice - discountAmount);
            totalAfterVAT = selectMultiPipeline.currencyIsRounded ?
                Math.round(total + Math.round((vatPercentage / 100) * total)) :
                total + ((vatPercentage / 100) * total);
        }

        if (isNaN(totalAfterVAT) || totalAfterVAT < 0) {
            setTotalProduct("")
        } else if (totalAfterVAT === 0) {
            setTotalProduct("0")
        } else {
            let result = (selectMultiPipeline.currencyCode === 'IDR' && selectMultiPipeline.currencyIsRounded) ? Math.round(Number(totalAfterVAT)) : roundDecimalToTwo(Number(totalAfterVAT))
            const formattedTotal = currencyFormatter(result.toString(), selectMultiPipeline.currencyIsRounded)
            setTotalProduct(formattedTotal)
        }
    }, [discountProduct, discountType, priceProduct, qtyProduct, vatProduct, originalPriceProduct, selectMultiPipeline, setTotalProduct, isIncludeVat])

    return {
        handleChangeValueResultTotal
    }
}

export default useHandleChangeResultPriceAndTotal